var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox styled",on:{"click":_vm.onClick}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.allChecked}}),_vm._v(" "),_c('label')])}
var staticRenderFns = []

export { render, staticRenderFns }